import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/resources';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.RESOURCE);

export const useResourceOptions = ({ sessionToken, resourceId, queryOptions = {} }) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(resourceId),
        queryFn: () => Client.fetchOne(sessionToken, resourceId),
        onSuccess: (data) => {
            console.log('Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        ...queryOptions
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
